<template>
  <div class="content">
    <!-- <img src="../assets/0ffice_banner.png" style="width:100%;height:100%;margin-bottom:-8px;"> -->
    <el-breadcrumb class="support_hearder" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
      <el-breadcrumb-item>Company</el-breadcrumb-item>
      <el-breadcrumb-item>egional Offices & Manufacturing Locations</el-breadcrumb-item>
    </el-breadcrumb>
    <h1>Locations</h1>
    <div class="message">
      <h2>USA</h2>
      <p>In the Bay Area, we have our distribution and technical support team, who work for hospital, academia and government customers.  Kelliop is committed to empowering our people to advance innovative technologies, developing meaningful solutions, and building rewarding careers. Kelliop strives to be the world leader in serving clinical science. We’re employing extraordinary minds from Berkeley and Stanford, who perform groundbreaking work to make significant contributions to healthcare.  Our success as a company is based on our global network, which operates as one open and collaborative environment. We empower our employees—not only in their use of cutting-edge technology, but also in their efforts to define their own career path and make a difference in the world. Together, we’re working to enable our customers to make the world healthier, cleaner, and safer.</p>
    </div>
    <div class="message">
      <h2>Singapore</h2>
      <p>In the Asia Pacific region, our success is driven by visionary leadership, intelligent strategy, and strong teamwork. Our presence in Southeast Asia includes regional office and marketing teams, and our global sourcing and manufacturing management team in Singapore. Our capabilities in the region allow us to focus on meeting our customers’ diverse needs with industry leading efficiency and speed.</p>
    </div>
    <div class="message" style="margin-bottom:148px;">
      <h2>Europe</h2>
      <p>Across Europe, we have a network of contract manufacturers and distributors, representing more than 50% of Kelliop’s manufacturing partners. Given the scope of our presence in Europe, we put great efforts in fostering strong and enduring relationships with a wide array of customers from hospitals, universities, healthcare companies and life science / research organizations.  Create your own Kelliop story by learning more about us – the work we do throughout the Europe and the breadth of career opportunities we can offer you.</p>
    </div>
  </div>
</template>
<script>
    export default {
        name: 'Offices',
        data () {
            return {

            }
        },
        mounted() {
        },
    }
</script>

<style scoped>
.content {
  width: 100%;
  height: auto;
}
.support_hearder {
  height: 38px;
  line-height: 38px;
  background:#f5f5f5;
  font-size:16px;
  color:#000000;
  padding-left: 30px;
}
h1 {
  font-size: 30px;
  color: #000000;
  margin: 50px 119px 77px 119px;
  font-weight: bold;
}
.message {
  padding: 0px 119px 36px 119px !important;
}
.message h2 {
  margin-bottom: 33px;
  color: #000000;
  font-size: 20px;
  font-weight: bold;
}
.message p {
  color: #343434;
  font-size: 16px;
  line-height: 30px;
}
::v-deep .el-breadcrumb__inner.is-link {
  font-weight: 400;
}
</style>